export const validateDates = (
    start_date: string,
    end_date: string) => {
    const errors: any = {};
    if (new Date(start_date!) >= new Date(end_date!)) {
        errors.end_date = "La fecha de fin del evento es menor a la fecha de inicio."
    }
    return errors
}